export const PrpListSelectedKey = 'PrpListSelected'
